import { Button, styled } from '@nextiva/next-ui-components';

const Footer = styled('div')`
  display: flex;
  position: fixed;
  bottom: 0;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 18px;
  margin-left: -24px;
  width: 100%;
  height: 5rem;
  background-color: #fff;
  border-top: 1px solid #c9e2e2;
  z-index: 1;
`;

const Action = styled('div')`
  width: 100%;
`;

const CancelBtn = styled(Button)`
  &.MuiButtonBase-root {
    height: 40px;
    width: 114px;
    color: rgba(0, 0, 0, 0.87);
    font-family: Lato;
    text-transform: capitalize;
    box-shadow: none;
    background-color: #e0e0e0;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 700;
  }
`;

const SaveBtn = styled(Button)`
  &.MuiButtonBase-root {
    height: 40px;
    width: 114px;
    color: white;
    font-family: Lato;
    text-transform: capitalize;
    box-shadow: none;
    background-color: #005fec;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 700;
  }
  &.MuiButton-contained.Mui-disabled {
    color: rgba(0, 0, 0, 0.26);
    box-shadow: none;
    background-color: rgba(0, 0, 0, 0.12);
  }
`;

export { Footer, Action, CancelBtn, SaveBtn };
